"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-thirteen/sections/technologySection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TechnologySectionTechnologyThirteensItem = {
    key: Key | null | undefined;
    /** Detected variants: "10" | "100" | "250K" */
    h30Text: ReactNode;
    /** Detected variants: "+" | "%" */
    span0Text: ReactNode;
    /** Detected variants: "Years of Experience" | "Satisfaction Rate" | "Verified Medecines" */
    p0Text: ReactNode;
    /** Detected variants: "technology-item-thirteen" */
    className?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};

type TechnologySectionDescriptionsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Our platform is built with a vision to transform healthcare through technology and trust. We partner with top pharmaceutical brands, licensed suppliers, and certified healthcare professionals to deliver original medicines and medical essentials." | "With secure online ordering, digital prescriptions, and fast delivery, we empower customers to access advanced healthcare from the comfort of their homes." */
    pText: ReactNode;
    /** Detected variants: "description" */
    className?: string;
};
export type HomeThirteenTechnologySectionGeneratedProps = {
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: TechnologySectionTechnologyThirteensItem) => Partial<ComponentProps<"h3">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "technology" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/technology-img-1.png" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "technology" */
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/technology-img-2.png" */
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "1s" */
    sectionDiv0Div0Div1Div0DivDataWowDuration?: string;
    /** Default: "We are a digital pharmacy focused on healthcare gaps through technology." */
    sectionDiv0Div0Div1Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div1Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div1Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    technologySectionTechnologyThirteens: TechnologySectionTechnologyThirteensItem[];
    technologySectionDescriptions: TechnologySectionDescriptionsItem[];
    technologySectionTechnologyThirteensItemWrapper?: (item: TechnologySectionTechnologyThirteensItem, content: ReactNode) => ReactNode;
    technologySectionTechnologyThirteensRenderer?: (defaultNode: ReactNode) => ReactNode;
    technologySectionTechnologyThirteensH3Visible?: boolean;
    technologySectionTechnologyThirteensH3Renderer?: (item: TechnologySectionTechnologyThirteensItem, defaultNode: ReactNode) => ReactNode;
    technologySectionTechnologyThirteensH3Props?: Partial<ComponentProps<"h3">> | ((item: TechnologySectionTechnologyThirteensItem) => Partial<ComponentProps<"h3">>);
    technologySectionDescriptionsItemWrapper?: (item: TechnologySectionDescriptionsItem, content: ReactNode) => ReactNode;
    technologySectionDescriptionsRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeThirteenTechnologySectionGenerated: FC<HomeThirteenTechnologySectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt = "technology",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/technology-img-1.png",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageAlt = "technology",
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/about/technology-img-2.png",
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div0Div1Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div1Div0H20H2Text = "We are a digital pharmacy focused on healthcare gaps through technology.",
    sectionDiv0Div0Div1Div0H20H2Visible,
    sectionDiv0Div0Div1Div0H20H2Renderer,
    sectionDiv0Div0Div1Div0H20H2Props,
    divH30H3Props,
    sectionDiv0Div0ClassName,
    technologySectionTechnologyThirteens,
    technologySectionDescriptions,
    technologySectionTechnologyThirteensItemWrapper,
    technologySectionTechnologyThirteensRenderer,
    technologySectionTechnologyThirteensH3Visible,
    technologySectionTechnologyThirteensH3Renderer,
    technologySectionTechnologyThirteensH3Props,
    technologySectionDescriptionsItemWrapper,
    technologySectionDescriptionsRenderer,
}) => {
    return (
        <section className="technology-section-thirteen section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row"}>
                    <div className="col-xl-5">
                        <div className="technology-img-thirteen">
                            {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath1ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath1ImageAlt} className="img-fluid img-2" {...(sectionDiv0Div0Div0Div0ImageWithBasePath1ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                    <div className="col-xl-7">
                        <div className="section-header section-header-thirteen wow fadeInUp" data-wow-duration={sectionDiv0Div0Div1Div0DivDataWowDuration}>
                            {renderNode(sectionDiv0Div0Div1Div0H20H2Visible, sectionDiv0Div0Div1Div0H20H2Renderer, (
                                <h2 className="section-title" {...(sectionDiv0Div0Div1Div0H20H2Props ?? {})}>
                                    {" "}
                                    {sectionDiv0Div0Div1Div0H20H2Text}
                                    {" "}
                                </h2>
                            ))}
                            {renderCollectionNode(
                                technologySectionDescriptions,
                                (item: TechnologySectionDescriptionsItem) => (
                                    <p className={item.className ?? "description"} key={item.key}>{item.pText}</p>
                                ),
                                technologySectionDescriptionsItemWrapper,
                                technologySectionDescriptionsRenderer
                            )}
                        </div>
                        <div className="technology-list-thirteen">
                            {renderCollectionNode(
                                technologySectionTechnologyThirteens,
                                (item: TechnologySectionTechnologyThirteensItem) => (
                                    <div className={item.className ?? "technology-item-thirteen"} key={item.key}>
                                        {renderItemNode(technologySectionTechnologyThirteensH3Visible, technologySectionTechnologyThirteensH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof technologySectionTechnologyThirteensH3Props === "function" ? technologySectionTechnologyThirteensH3Props(item) : (technologySectionTechnologyThirteensH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>
                                                {item.h30Text}
                                                <span>{item.span0Text}</span>
                                                {" "}
                                            </h3>
                                        ))}
                                        <p>{item.p0Text}</p>
                                    </div>
                                ),
                                technologySectionTechnologyThirteensItemWrapper,
                                technologySectionTechnologyThirteensRenderer
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeThirteenTechnologySectionGenerated;
